import { render, staticRenderFns } from "./AddEditRecipients.vue?vue&type=template&id=34a6e26a&scoped=true&"
import script from "./AddEditRecipients.vue?vue&type=script&lang=js&"
export * from "./AddEditRecipients.vue?vue&type=script&lang=js&"
import style0 from "./AddEditRecipients.vue?vue&type=style&index=0&id=34a6e26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a6e26a",
  null
  
)

export default component.exports